import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { MyEInvoiceToIrbContainerContainerModel } from '../../../../../models/aggregates/e-invoice/my-einvoice-to-irb-hdr-container.model';


@Injectable({
  providedIn: 'root'
})

export class MyEInvoiceToIRBHdrService extends BaseApiPublicLoginTemplateService<MyEInvoiceToIrbContainerContainerModel, MyEInvoiceToIrbContainerContainerModel, MyEInvoiceToIrbContainerContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.BACKOFFICE_EP
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.LOGIN_EP
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/e-invoice/to-irbs/' + BaseApiTemplateService.LOGIN_ENTITY_EP
    this.httpClient = http;
  }

}
